import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import states from "../../data/states";
import countries from "../../data/countriesList";
import residencyCountries from "../../data/residencyCountries";
import residencyDistrict from "../../data/residencyDistrict";
import livingStatusList from "../../data/livingStatusList";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import { toast } from "react-toastify";

const EditLeloForm = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const adminLeloContext = useContext(AdminLeloContext);
  const { updateLeloEntrie, getLeloEntrie, clearLeloEntrie, Leloentrie } =
    adminLeloContext;
  const [districtOptions, setDistrictOptions] = useState([]);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");

  const [formData, setFormData] = useState({
    _id: "",
    charter: "",
    charter_id: "",
    hasPreviouslyEnrolled: false,
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    birthDate: "",
    studentEmail: "",
    studentPrimaryPhone: "",
    studentPrimaryPhoneType: "",
    pgFirstName: "",
    pgLastName: "",
    pgRelationshipToStudent: "",
    pgPrimaryEmail: "",
    pgPrimaryPhone: "",
    pgPrimaryPhoneType: "",
    liveWithPg: false,
    livingStatus: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    district: "",
    isMailingAddressTheSame: false,
    mailingStreet: "",
    mailingCity: "",
    mailingState: "",
    mailingZip: "",
    gradeLevel: "",
    courses: [],
    selectedCourseAgreements: [],
    studentSignature: "",
    studentName: "",
    studentSignatureDate: "",
    parentSignature: "",
    parentName: "",
    parentSignatureDate: "",
    learningCenters: [],
  });

  const alphabetRegex = /^[A-Za-z\s]+$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    const alphabeticFields = [
      "firstName",
      "lastName",
      "pgFirstName",
      "pgLastName",
      "pgRelationshipToStudent",
      "state",
      "district",
      "city",
      "country",
      "mailingStreet",
      "mailingCity",
      "mailingState",
      "mailingZip",
    ];

    if (name === "country") {
      // Update the district options based on the selected country
      const selectedCountry = value;
      if (residencyDistrict[selectedCountry]) {
        setDistrictOptions(residencyDistrict[selectedCountry]);
      } else {
        setDistrictOptions([]); 
      }
    }

    if (name === "zip") {
      const numericValue = value.trim();

      if (!/^\d{0,5}$/.test(numericValue)) {
        setError("ZIP code must be 5 digits.");
        return;
      }

      if (value.length < 5) {
        setError("ZIP code must be 5 digits.");
      } else {
        setError("");
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: numericValue,
      }));
      return;
    }
    if (name === "mailingZip") {
      const numericValue = value.trim();

      if (!/^\d{0,5}$/.test(numericValue)) {
        setError1("ZIP code must be 5 digits.");
        return;
      }

      if (value.length < 5) {
        setError1("ZIP code must be 5 digits.");
      } else {
        setError1("");
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: numericValue,
      }));
      return;
    }

    if (
      alphabeticFields.includes(name) &&
      value !== "" &&
      !alphabetRegex.test(value)
    ) {
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (formData.country) {
      // If there's already a country selected, set the district options accordingly
      const selectedCountry = formData.country;
      if (residencyDistrict[selectedCountry]) {
        setDistrictOptions(residencyDistrict[selectedCountry]);
      }
    }
  }, [formData.country]);

  const validateEmail = (email) => {
    const reg =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number));
  };

  const formatPhoneNumber = (evt) => {
    let aVal = evt.target.value.replace(/\D/g, "");

    if (aVal.length >= 10 && aVal.charAt(0) === "1") {
      aVal = aVal.substring(1);
    }

    if (aVal.length > 0) {
      if (aVal.length > 6) {
        aVal = `${aVal.substring(0, 3)}-${aVal.substring(
          3,
          6
        )}-${aVal.substring(6, 10)}`;
      } else if (aVal.length > 3) {
        aVal = `${aVal.substring(0, 3)}-${aVal.substring(3, 6)}`;
      } else {
        aVal = aVal;
      }
    }

    evt.target.value = aVal;
  };

  useEffect(() => {
    getLeloEntrie(_id);
    return () => {
      clearLeloEntrie();
    };
  }, []);

  useEffect(() => {
    if (Leloentrie) {
      setFormData({
        ...Leloentrie,
      });
    }
  }, [Leloentrie]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(formData.studentEmail)) {
      toast.error("Please provide a valid email address.");
    //  alert("Please provide a valid email address.");
      return;
    }
    if (!validatePhone(formData.studentPrimaryPhone)) {
      toast.error("Please provide a valid phone number in the format XXX-XXX-XXXX.");
      return;
    }
  
    // Validate parent/guardian email and phone only if the relationship is not "Self 18+"
    if (
      formData.pgRelationshipToStudent !== "Self 18+" &&
      (!validateEmail(formData.pgPrimaryEmail) ||
        !validatePhone(formData.pgPrimaryPhone))
    ) {
      if (!validateEmail(formData.pgPrimaryEmail)) {
        toast.error("Please provide a valid parent/guardian email address.");
        return;
      }

      if (!validatePhone(formData.pgPrimaryPhone)) {
        toast.error("Please provide a valid parent/guardian phone number in the format XXX-XXX-XXXX.");
        return;
      }
    }
    updateLeloEntrie(_id, formData);
    navigate(-1);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Edit Lelo Form</title>
      </Helmet>
      <h1 className="top-title text-center">Edit Lelo Form</h1>
      <div className="top-container">
        <div
          className="right display-back"
          style={{ fontSize: "18px", marginLeft:"40px" }}
          onClick={() => {
            navigate(-1);
          }}
        >
          <FaIcons.FaArrowAltCircleLeft className="back-icon" />
          <h4>Back</h4>
        </div>
      </div>
      <div id="interest-form-page">
        <div className="interest-form">
          <div className="container">
            {Leloentrie ? (
              <form onSubmit={handleSubmit}>
                <div className="sub-forms">
                  <div className="sub-form">
                    <h3>Selected Learning Center</h3>
                    <div>
                      <h4>Site:</h4>
                      <input
                        type="text"
                        name="learningCenterName"
                        value={formData.learningCenters}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div>
                      <h4>Charter:</h4>
                      <input type="text" value={formData.charter} disabled />
                    </div>
                  </div>

                  <div className="sub-form">
                    <h3>Student Information</h3>
                    <div>
                      <h4>
                        Previously Enrolled:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="hasPreviouslyEnrolled"
                        value={formData.hasPreviouslyEnrolled}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        Student's First Name:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>

                    <div>
                      <h4>Student's Middle Name: </h4>
                      <input
                        type="text"
                        name="middleName"
                        value={formData.middleName}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </div>
                    <div>
                      <h4>
                        Student's Last Name:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>

                    <div>
                      <h4>
                        Gender: 
                        <span className="required-asterisk">*</span>
                      </h4>

                      <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select</option>
                        <option value="Female">Female</option>
                        <option value="Male">Male</option>
                        <option value="Non-Binary">Non-Binary</option>
                      </select>
                    </div>

                    <div>
                      <h4>
                        Birth Date: <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="date"
                        name="birthDate"
                        value={
                          formData.birthDate
                            ? moment(formData.birthDate).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        Email: <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="email"
                        name="studentEmail"
                        value={formData.studentEmail}
                        onChange={handleChange}
                        maxLength={60}
                        required
                        className={
                          validateEmail(formData.studentEmail)
                            ? "success-border"
                            : "error-border"
                        }
                      />
                      {!validateEmail(formData.studentEmail) && (
                        <p className="validation-msg">
                          Please provide a valid email address.
                        </p>
                      )}
                    </div>
                    <div>
                      <h4>
                        Phone Number: <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="studentPrimaryPhone"
                        maxLength="12"
                        value={formData.studentPrimaryPhone}
                        onChange={(e) => {
                          formatPhoneNumber(e);
                          handleChange(e);
                        }}
                        placeholder="XXX-XXX-XXXX"
                        required
                        className={
                          validatePhone(formData.studentPrimaryPhone)
                            ? "success-border"
                            : "error-border"
                        }
                      />
                      {!validatePhone(formData.studentPrimaryPhone) && (
                        <p className="validation-msg">
                          Please provide a valid phone number in the format
                          XXX-XXX-XXXX.
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Parent/Guardian Input Form */}
                  <div className="sub-form">
                    <h3>Parent/Guardian Information</h3>
                    <div>
                      <h4>
                        Your Relationship to {formData.firstName}:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="pgRelationshipToStudent"
                        value={formData.pgRelationshipToStudent}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {formData.pgRelationshipToStudent!== "Self 18+" && (
                     <>
                    <div>
                      <h4>
                        Parent First Name:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="pgFirstName"
                        value={formData.pgFirstName}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        Parent Last Name:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="pgLastName"
                        value={formData.pgLastName}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        Email: <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="email"
                        name="pgPrimaryEmail"
                        value={formData.pgPrimaryEmail}
                        onChange={handleChange}
                        maxLength={60}
                        required
                        className={
                          validateEmail(formData.pgPrimaryEmail)
                            ? "success-border"
                            : "error-border"
                        }
                      />
                      {!validateEmail(formData.pgPrimaryEmail) && (
                        <p className="validation-msg">
                          Please provide a valid email address.
                        </p>
                      )}
                    </div>
                    <div>
                      <h4>
                        Phone Number: <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="pgPrimaryPhone"
                        maxLength="12"
                        value={formData.pgPrimaryPhone}
                        onChange={(e) => {
                          formatPhoneNumber(e);
                          handleChange(e);
                        }}
                        placeholder="XXX-XXX-XXXX"
                        required
                        className={
                          validatePhone(formData.pgPrimaryPhone)
                            ? "success-border"
                            : "error-border"
                        }
                      />
                      {!validatePhone(formData.pgPrimaryPhone) && (
                        <p className="validation-msg">
                          Please provide a valid phone number in the format
                          XXX-XXX-XXXX.
                        </p>
                      )}
                    </div>
                    </>
                    )}
                  </div>

                  <div className="sub-form">
                    <h3>Physical Address</h3>
                    <div>
                      <h4>
                      Lives with Parent:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="liveWithPg"
                        value={formData.liveWithPg}
                        onChange={handleChange}
                        maxLength={10}
                        required
                      />
                    </div>

                    <div>
                      <h4>
                        Living Status : <span className="required-asterisk">*</span>
                      </h4>

                      <select
                        name="livingStatus"
                        value={formData.livingStatus}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Please Select</option>
                        {livingStatusList.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <h4>
                        Street : <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="street"
                        value={formData.street}
                        onChange={handleChange}
                        maxLength={50}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        City: <span className="required-asterisk">*</span>
                      </h4>

                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        maxLength={25}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        State: <span className="required-asterisk">*</span>
                      </h4>

                      <select
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Please Select</option>
                        {states.map((item) => (
                          <option
                            key={Object.keys(item)[0]}
                            value={Object.keys(item)[0]}
                          >
                            {Object.keys(item)[0]}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <h4>
                        ZIP Code: <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="zip"
                        value={formData.zip}
                        placeholder="XXXXX"
                        onChange={handleChange}
                        maxLength={5}
                        required
                        className={error ? "error-border" : ""}
                      />
                      {error && (
                        <p className="validation-msg" style={{ color: "red" }}>
                          {error}
                        </p>
                      )}
                    </div>

                    <div>
                      <h4>
                        County of Residence:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>

                      <select
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Please Select</option>
                        {residencyCountries.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <h4>
                        District: <span className="required-asterisk">*</span>
                      </h4>

                      <select
                        name="district"
                        value={formData.district}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Please Select</option>
                        {districtOptions.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {formData.isMailingAddressTheSame &&
                    (formData.mailingStreet ||
                      formData.mailingCity ||
                      formData.mailingState ||
                      formData.mailingZip) && (
                      <div className="sub-form">
                        <h3>Mailing Address</h3>
                        <div>
                          <h4>
                            Mailing Street :{" "}
                            <span className="required-asterisk">*</span>
                          </h4>

                          <input
                            type="text"
                            name="mailingStreet"
                            value={formData.mailingStreet}
                            onChange={handleChange}
                            maxLength={50}
                            required
                          />
                        </div>
                        <div>
                          <h4>
                            Mailing City:{" "}
                            <span className="required-asterisk">*</span>
                          </h4>

                          <input
                            type="text"
                            name="mailingCity"
                            value={formData.mailingCity}
                            onChange={handleChange}
                            maxLength={25}
                            required
                          />
                        </div>
                        <div>
                          <h4>
                            Mailing State:{" "}
                            <span className="required-asterisk">*</span>
                          </h4>

                          <input
                            type="text"
                            name="mailingState"
                            value={formData.mailingState}
                            onChange={handleChange}
                            maxLength={25}
                            required
                          />
                        </div>
                        <div>
                          <h4>
                            Mailing Zip/Postal Code:{" "}
                            <span className="required-asterisk">*</span>
                          </h4>

                          <input
                            type="text"
                            name="mailingZip"
                            value={formData.mailingZip}
                            onChange={handleChange}
                            maxLength={5}
                            required
                            placeholder="XXXXX"
                            className={error1 ? "error-border" : ""}
                          />
                          {error1 && <p className="validation-msg">{error1}</p>}
                        </div>
                      </div>
                    )}

                  <div className="sub-form">
                    <h3>Registration for Classes</h3>
                    <div>
                      <h4>
                        Previously Enrolled:{" "}
                        <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="hasPreviouslyEnrolled"
                        value={formData.hasPreviouslyEnrolled}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>
                    <div>
                      <h4>
                        Grade Level: <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="gradeLevel"
                        value={formData.gradeLevel}
                        onChange={handleChange}
                        maxLength={5}
                        required
                      />
                    </div>
                    {formData.courses?.map((course, idx) => (
                      <div key={idx} className="sum-item">
                        <div>
                          <h4>Course {idx + 1}:</h4>
                          <input
                            type="text"
                            name={`course_name_${idx}`}
                            value={course.course_name}
                            disabled
                            // style={{
                            //   border: "1px solid #ccc",
                            //   backgroundColor: "#f9f9f9",
                            //   padding: "5px",
                            //   width: "100%",
                            // }}
                          />
                        </div>
                        <div style={{ marginLeft: "15px" }}>
                          <h4>Credits:</h4>
                          <input
                            type="text"
                            name={`credits_${idx}`}
                            value={
                              formData.selectedCourseAgreements[idx] || "N/A"
                            }
                            disabled
                            // style={{
                            //   border: "1px solid #ccc",
                            //   backgroundColor: "#f9f9f9",
                            //   padding: "5px",
                            //   width: "100%",
                            // }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="sub-form">
                    <h3>Agreement</h3>
                    <div>
                      <h4>
                        Student Name: <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="studentName"
                        value={formData.studentName}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>
                    <div>
                      <h4>Student Signature Date: </h4>
                      <input
                        type="text"
                        name="studentSignatureDate"
                        value={
                          formData.studentSignatureDate
                            ? moment(formData.studentSignatureDate).format(
                                "MM/DD/YYYY"
                              )
                            : ""
                        }
                        disabled
                        required
                      />
                    </div>
                    <div>
                      <h4>Student Signature: </h4>
                      <div>
                        <img
                          src={formData.studentSignature}
                          alt="Student Signature"
                        />
                      </div>
                    </div>
                    {formData.pgRelationshipToStudent!== "Self 18+" && (
                     <>
                    <div>
                      <h4>
                        Parent Name: <span className="required-asterisk">*</span>
                      </h4>
                      <input
                        type="text"
                        name="parentName"
                        value={formData.parentName}
                        onChange={handleChange}
                        maxLength={30}
                        required
                      />
                    </div>
                    <div>
                      <h4>Parent Signature Date: </h4>
                      <input
                        type="text"
                        name="parentSignatureDate"
                        value={
                          formData.parentSignatureDate
                            ? moment(formData.parentSignatureDate).format(
                                "MM/DD/YYYY"
                              )
                            : ""
                        }
                        disabled
                        required
                      />
                    </div>
                    <div>
                      <h4>Parent Signature: </h4>

                      <div>
                        <img
                          src={formData.parentSignature}
                          alt="parentSignature"
                        />
                      </div>
                    </div>
                    </>
                    )}
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </form>
            ) : (
              <div>No data available for this entry.</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLeloForm;
